import styled from 'styled-components';
import { getProductNameTextFromApiName } from '../_core/common/adapters/getProductNameText';
import TranslatedFeature from './TranslatedFeature';
import { sortProductApiNamesLowToHigh } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledTooltipSection = styled.div.withConfig({
  displayName: "ProductFeatureLongLimit__StyledTooltipSection",
  componentId: "sqq848-0"
})(({
  theme
}) => ({
  marginBlockEnd: theme.space['200'],
  '&:last-child': {
    marginBottom: theme.space['0']
  }
}));
const ProductFeatureLongLimit = ({
  feature,
  apiName,
  onlyShowCurrentLongLimit
}) => {
  if (!feature.longLimits || !Object.keys(feature.longLimits).length) {
    return null;
  }
  const apiNamesWithLongLimits = onlyShowCurrentLongLimit ? [apiName] : feature.productApiNames.filter(productApiName => feature.longLimits[productApiName]);
  const sortedApiNames = sortProductApiNamesLowToHigh(apiNamesWithLongLimits);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: sortedApiNames.map(sortedApiName => {
      const key = `tooltip-${sortedApiName}-${feature.featureId}`;
      return /*#__PURE__*/_jsxs(StyledTooltipSection, {
        id: key,
        children: [/*#__PURE__*/_jsxs("b", {
          children: [getProductNameTextFromApiName(sortedApiName), /*#__PURE__*/_jsx("span", {
            children: ":"
          })]
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(TranslatedFeature, {
            feature: feature,
            apiName: sortedApiName,
            attribute: "longLimits"
          })
        })]
      }, key);
    })
  });
};
export default ProductFeatureLongLimit;